import axios from 'axios';

let store = null;

export const setStore = loadingStore => {
  store = loadingStore;
};

export const instance = axios.create({
  baseURL: process.env.REACT_APP_REST_URL,
  timeout: 200000,
});

export const notLoginInstance = axios.create({
  baseURL: process.env.REACT_APP_NOT_LOGIN_URL,
  timeout: 10000,
});

instance.interceptors.request.use(
  config => {
    const token = sessionStorage.getItem('token');
    config.headers = {
      ...config.headers,
      'Cache-Control': 'no-cache',
      Authorization: token ? `Bearer ${token}` : '',
      Pragma: 'no-cache',
    };

    if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json;charset=UTF-8';
    }

    if (store?.setLoading) {
      store.setLoading(true);
    }
    return config;
  },
  error => {
    if (store?.setLoading) {
      store.setLoading(false);
    }

    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  response => {
    if (store?.setLoading) {
      store.setLoading(false);
    }

    return response;
  },
  error => {
    if (store?.setLoading) {
      store.setLoading(false);
    }

    if (error.response && error.response.status === 502) {
      window.location.href = '/error';
    }

    if (error.response && error.response.status === 401) {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('appStore');
      window.location.href = '/member/login';
    }

    return Promise.reject(error);
  }
);

notLoginInstance.interceptors.request.use(
  config => {
    if (store?.setLoading) {
      store.setLoading(true);
    }
    return config;
  },
  error => {
    if (store?.setLoading) {
      store.setLoading(false);
    }
    return Promise.reject(error);
  }
);

notLoginInstance.interceptors.response.use(
  response => {
    if (store?.setLoading) {
      store.setLoading(false);
    }
    return response;
  },
  error => {
    if (error.response && error.response.status > 500) {
      window.location.href = '/error';
    }
    if (store?.setLoading) {
      store.setLoading(false);
    }

    return Promise.reject(error);
  }
);
